import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable, merge } from 'rxjs';
import { filter, map, scan, shareReplay, withLatestFrom } from 'rxjs/operators';
import { WebPopService } from '../services';
import { shareReplayRefCount } from '@adreno-common';

@Component({
  selector: 'app-web',
  templateUrl: './web.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebComponent {
  private tabIndex$: Observable<number>;
  viewModel$: Observable<ViewModel>;

  constructor(
    private webPop: WebPopService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute
  ) {
    this.tabIndex$ = this.route.paramMap.pipe(
      filter((pm) => pm.has('tabIndex')),
      map((pm) => +pm.get('tabIndex')!),
      shareReplayRefCount()
    );
    this.viewModel$ = this.initViewModel();
  }

  private initViewModel() {
    return merge<Partial<ViewModel>>(
      this.tabIndex$.pipe(
        withLatestFrom(this.webPop.webTabs$),
        map(([tabIndex, webTabs]) => ({
          webUrl: webTabs
            ? webTabs[tabIndex].url
              ? this.sanitizer.bypassSecurityTrustResourceUrl(
                  webTabs[tabIndex].url!
                )
              : undefined
            : undefined,
        }))
      )
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }
}

interface ViewModel {
  webUrl?: SafeResourceUrl;
}
